import { render, staticRenderFns } from "./RewardTermsModal.vue?vue&type=template&id=22a6a12c&scoped=true&"
import script from "./RewardTermsModal.vue?vue&type=script&lang=js&"
export * from "./RewardTermsModal.vue?vue&type=script&lang=js&"
import style0 from "./RewardTermsModal.vue?vue&type=style&index=0&id=22a6a12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6a12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22a6a12c')) {
      api.createRecord('22a6a12c', component.options)
    } else {
      api.reload('22a6a12c', component.options)
    }
    module.hot.accept("./RewardTermsModal.vue?vue&type=template&id=22a6a12c&scoped=true&", function () {
      api.rerender('22a6a12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/components/modals/RewardTermsModal.vue"
export default component.exports